import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import classnames from 'classnames';

import { StaticImage } from '@nxte-nl/static-image';

import hand_1 from '../../images/hands/small/hand_1.webp';
import hand_2 from '../../images/hands/small/hand_2.webp';
import hand_3 from '../../images/hands/small/hand_3.webp';
import { LayoutExtension } from '../../types/ResponsiveState';
import styles from './Hand.module.css';

const messages = defineMessages({
  hand1Alt: {
    id: 'src.components.Hand.hand1Alt',
    defaultMessage: 'hand_1',
  },
  hand2Alt: {
    id: 'src.components.Hand.hand2Alt',
    defaultMessage: 'hand_2',
  },
  hand3Alt: {
    id: 'src.components.Hand.hand3Alt',
    defaultMessage: 'hand_3',
  },
});

export let counter = 0;

export const CARD_HANDS = [
  {
    url: hand_1,
    cssClass: styles.hand1Container,
    desktopSize: {
      width: 229,
      height: 270,
    },
    mobileSize: {
      width: 174,
      height: 205,
    },
  },
  {
    url: hand_2,
    cssClass: styles.hand2Container,
    desktopSize: {
      width: 192,
      height: 350,
    },
    mobileSize: {
      width: 123,
      height: 220,
    },
  },
  {
    url: hand_3,
    cssClass: styles.hand3Container,
    desktopSize: {
      width: 270,
      height: 340,
    },
    mobileSize: {
      width: 160,
      height: 250,
    },
  },
];

export const AMOUNT_OF_HANDS = 3;

export type GetImageParams = {
  height: number;
  url: string;
  width: number;
};

export const hooks = {
  useCounter() {
    counter++;
    return counter;
  },
};

// NOTE: this component fully depends on ProductCard component
export type Props = {
  isCropped?: boolean;
  layoutExtension: LayoutExtension;
};
export const Hand = React.memo((props: Props) => {
  const { layoutExtension, isCropped } = props;
  const intl = useIntl();

  const counter = hooks.useCounter();
  const hand = CARD_HANDS[counter % AMOUNT_OF_HANDS];
  const {
    width,
    height,
  } = layoutExtension === LayoutExtension.Mobile ? hand.mobileSize : hand.desktopSize;
  const handAlt = intl.formatMessage(
    messages[`hand${counter % AMOUNT_OF_HANDS + 1}Alt` as keyof typeof messages],
  );

  return (
    <div className={classnames(styles.handContainer, hand.cssClass, {
      [styles.mobile]: layoutExtension === LayoutExtension.Mobile,
      [styles.tablet]: layoutExtension === LayoutExtension.Tablet,
      [styles.cropped]: isCropped,
    })}>
      <StaticImage
        alt={handAlt}
        width={width}
        height={height}
        src={hand.url}
      />
    </div>
  );
});

Hand.displayName = 'Hand';
